<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 d-flex acry-page-title justify-content-center" style="gap:8px; margin-bottom: 40px;">
        <img src="@/assets/acrypro/coupon/step3.svg" />
        <div v-if="!this.$store.state.acrylicTicketCouponManager.orderData.isSample">チケットコード発行・決済</div>
        <div v-if="this.$store.state.acrylicTicketCouponManager.orderData.isSample">サンプル用チケットコード発行・決済</div>
      </div>
      <div class="d-flex flex-column align-items-center" style="background:#F5F7FA; padding:16px;">
        <div class="d-flex flex-column text-start" style="width: 510px; color: #BC6665; font-size: 13px;">
          <p class="m-0">【注意事項】</p>
          <p class="m-0">● 発行されたチケットコードは 一度のみ使用可能です。</p>
          <p class="m-0">● システムメンテナンス等により、一時的にご利用いただけない場合があります。</p>
          <p class="m-0">● 発行枚数が多いと発行に時間がかかることがあります。</p>
          <p class="m-0">● 一度発行したチケットコードの設定は削除できませんのでご注意ください。</p>
        </div>
      </div>

      <div class="d-flex flex-column text-start" style="background:#F8F8F8; padding:32px; gap:32px;">
        <div class="d-flex" style="gap:64px;">
          <div class="acry-text-main d-flex" style="width:180px; height:24px; font-size: 16px;">
            <div class="fw-bold">数量</div>
            <div class="ms-auto mustlbl">必須</div>
          </div>
          <div class="d-flex flex-column flex-grow-1" style="gap:16px;">
            <input class="flex-grow-1 w-100 acry-input" style="padding:10px; height:40px;" type="text" placeholder="注文枚数" @blur="numBlur" v-model="$store.state.acrylicTicketCouponManager.orderData.count"/>
          </div>
        </div>
        <div class="d-flex" style="gap:64px;">
          <div class="acry-text-main d-flex" style="width:180px; height:24px; font-size: 16px;">
            <div class="fw-bold">コード有効期限</div>
            <div class="ms-auto mustlbl">必須</div>
          </div>
          <div class="d-flex flex-column flex-grow-1" style="gap:16px;">
            <div>
              <input class="acry-input acry-text-title" style="width:250px; padding-left: 90px;" type="date" v-model="fromDate" />
              <span class="h-100 acry-text-title my-auto" style="padding: 10px;">〜</span>
              <input class="acry-input acry-text-title" style="width:250px; padding-left: 90px;" type="date" v-model="toDate" />
            </div>
            <div class="acrypro-text-main" style="font-size:12px;">
              ● 有効期限は最大6ヶ月です。開始日を最大半年後までに設定できます。
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column" style="border: 1px solid #D1D5DB; padding: 16px; gap: 8px;">
        <div class="fw-bold" style="font-size: 17px;">
          決済内容
        </div>
        <div class="d-flex flex-column" style="font-size: 15px; gap: 8px; border-bottom: solid 1px #D1D5DB;">
          <div class="d-flex justify-content-between">
            <div>チケットコード代金</div>
            <div>{{ticketPrice.toLocaleString("ja-JP", { style: "currency", currency: "JPY" })}}</div>
          </div>
          <div class="d-flex justify-content-between" style="color: #BC6665;">
            <div>割引金額</div>
            <div>{{(-discount).toLocaleString("ja-JP", { style: "currency", currency: "JPY" }).replace(/^-(￥)/, "$1-")}}</div>
          </div>
          <div class="d-flex justify-content-between">
            <div>送料代<span style="font-size:12px;">（チケット発行者負担分）</span></div>
            <div>{{delivPrice.toLocaleString("ja-JP", { style: "currency", currency: "JPY" })}}</div>
          </div>
          <div class="d-flex justify-content-between">
            <div>消費税</div>
            <div>{{totalTax.toLocaleString("ja-JP", { style: "currency", currency: "JPY" })}}</div>
          </div>
        </div>
        <div>
          <div class="d-flex justify-content-between fw-bold">
            <div style="font-size: 20px;">ご注文合計金額</div>
            <div style="font-size: 28px;">{{totalPrice.toLocaleString("ja-JP", { style: "currency", currency: "JPY" })}}</div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center" style="gap:32px;">
        <button class="mx-0 acry-btn-sub fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickReturnBtn">
          もどる
        </button>
        <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 54px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickConfirmBtn">
          確認画面へ
        </button>
      </div>
    </div>



  </div>
</template>

<script>
import { CenterViewState } from "@/js/Const.js";
import { CalculationTicketOrderPrice } from "@/js/CommonFunc.js";
import { Analytics } from "@/js/Analytics.js";



export default {
  name: "CenterViewEventTicketIssue_Ap",
  props: {},
  data: function () {
    return {
      fromDate:"",
      toDate:"",
      ticketPrice: 0,
      discount: 0,
      delivPrice: 0,
      totalTax: 0,
      totalPrice: 0,
    };
  },
  watch:{
    // "$store.state.acrylicTicketCouponManager.orderData.count"(){
    //   const orderPrice = CalculationTicketOrderPrice(
    //     this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,
    //     this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee,
    //     this.$store.state.acrylicTicketCouponManager.orderData.count,
    //     this.$store.state.acrylicTicketCouponManager.orderData.isSample
    //     );

    //   this.ticketPrice = orderPrice.ticketPrice;
    //   this.discount = orderPrice.discount;
    //   this.delivPrice = orderPrice.delivPrice;
    //   this.totalTax = orderPrice.totalTax;
    //   this.totalPrice = orderPrice.totalPrice;
    // },
    "fromDate"(){
      const from = new Date(this.fromDate);
      const now = new Date(this.formatDate(new Date()));
      const max = new Date(this.formatDate(new Date()));
      max.setMonth(max.getMonth() + 6);

      // 終了日は明日以降じゃないとダメ
      if( now > from ){
        this.fromDate = this.formatDate(now);
        this.$store.commit("showMessage", "開始日は本日以降の日付を入れてください");
      }

      // 終了日は最大1年後まで
      if( max < from ){
        this.fromDate = this.formatDate(max);
        this.$store.commit("showMessage", "開始日は最大6ヶ月後までです");
      }

      // 開始日を変更すると自動的に終了日を設定
      const to = new Date(this.fromDate);
      to.setMonth(to.getMonth() + 6);
      this.toDate = this.formatDate(to);
    },
    "toDate"(){
      const to = new Date(this.toDate);
      const from = new Date(this.fromDate);
      const now = new Date(this.formatDate(new Date()));
      const max = new Date(this.fromDate);
      max.setMonth(max.getMonth() + 6);

      // 終了日は明日以降じゃないとダメ
      if( now > to ){
        this.toDate = this.formatDate(max);
        this.$store.commit("showMessage", "終了日は本日以降の日付を入れてください");
      }

      // 終了日は開始日以降じゃないとダメ
      if( from > to ){
        this.toDate = this.formatDate(from);
        this.$store.commit("showMessage", "終了日は開始日以降の日付を入れてください");
      }

      // 終了日は最大1年後まで
      if( max < to ){
        this.toDate = this.formatDate(max);
        this.$store.commit("showMessage", "有効期限は最大6ヶ月です");
      }
    },
  },
  computed: {

  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.update().catch((e) => {
      this.$handleError("036", e, { hideLoading: true });
    });

    // 初期値を設定
    const now = new Date();
    this.fromDate = this.formatDate(now);
    now.setMonth(now.getMonth() + 6);
    this.toDate = this.formatDate(now);

    const orderPrice = CalculationTicketOrderPrice(
      this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,
      this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee,
      this.$store.state.acrylicTicketCouponManager.orderData.count,
      this.$store.state.acrylicTicketCouponManager.orderData.isSample
      );

    this.ticketPrice = orderPrice.ticketPrice;
    this.discount = orderPrice.discount;
    this.delivPrice = orderPrice.delivPrice;
    this.totalTax = orderPrice.totalTax;
    this.totalPrice = orderPrice.totalPrice;

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    numBlur(){
      if( isNaN(this.$store.state.acrylicTicketCouponManager.orderData.count) ) this.$store.state.acrylicTicketCouponManager.orderData.count = 1;
      if( this.$store.state.acrylicTicketCouponManager.orderData.count < 1 ) this.$store.state.acrylicTicketCouponManager.orderData.count = 1;
      if( this.$store.state.acrylicTicketCouponManager.orderData.count > 1000000 ) this.$store.state.acrylicTicketCouponManager.orderData.count = 1000000;

      const orderPrice = CalculationTicketOrderPrice(
        this.$store.state.acrylicTicketCouponManager.orderData.ticketProductId,
        this.$store.state.acrylicTicketCouponManager.orderData.isShippingFee,
        this.$store.state.acrylicTicketCouponManager.orderData.count,
        this.$store.state.acrylicTicketCouponManager.orderData.isSample
        );

      this.ticketPrice = orderPrice.ticketPrice;
      this.discount = orderPrice.discount;
      this.delivPrice = orderPrice.delivPrice;
      this.totalTax = orderPrice.totalTax;
      this.totalPrice = orderPrice.totalPrice;
    },
    /**
     * Date型の日付を「YYYY-MM-DD HH:mm:ss」の文字列に変換する
     * @param {Date} date
     * @return {string}
     */
    formatDate(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    },
    clickReturnBtn(){
      this.$store.commit("setCenterViewState", CenterViewState.EventEdit);
    },
    clickConfirmBtn(){
      // データチェック
      if( isNaN(this.$store.state.acrylicTicketCouponManager.orderData.count) || this.$store.state.acrylicTicketCouponManager.orderData.count < 1 ){
        this.$store.commit("showMessage", "ご注文枚数を正しく設定してください");
        return;
      }

      if( isNaN(Date.parse(this.fromDate)) ){
        this.$store.commit("showMessage", "開始日を正しく設定してください");
        return;
      }

      if( isNaN(Date.parse(this.toDate)) ){
        this.$store.commit("showMessage", "終了日を正しく設定してください");
        return;
      }

      if( new Date(this.fromDate) > new Date(this.toDate) ){
        this.$store.commit("showMessage", "開始日より過去に終了日が設定されています");
        return;
      }

      this.$store.state.acrylicTicketCouponManager.orderData.fromDate = this.fromDate;
      this.$store.state.acrylicTicketCouponManager.orderData.toDate = this.toDate;
      this.$store.state.acrylicTicketCouponManager.orderData.preview = this.$store.state.eventCreateData.previewData.fileURL;

      Analytics.acryTicketStep3Completed();

      this.$store.commit("setCenterViewState", CenterViewState.TicketOrderConfirm);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.event-cell{
  gap: 24px;
  height: 186px;
  padding: 16px;
  border-bottom: solid 1px $border-sub-color;
  &:last-child { border-bottom: none; } // 最終行だけいらない
}

.mustlbl {
  color: white;
  background: #bc6665;
  border-radius: 4px;
  margin: 0px;
  padding: 0px 10px;
}

input[type="date"] {
  position: relative;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  background: transparent;
  z-index: 1;
}

input[type="date"]::after {
  content: '';
  background-image: url('~@/assets/acrypro/ico_calendar.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 0 0;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50%;
  left: 17px;
  transform: translateY(-50%);
}

.acry-btn-sub {
  // margin: 10px;
  padding: 3px 30px;
  color: $primary-main-color;
  background-color: #ffffff;
  border: solid 2px $border-main-color;
  border-radius: 15px;
  font-size: 15px;
}
</style>


